import { KindergartenRoleEnum } from "@king-ict/eupisi-ui/models";

import { PermissionEnum } from "../Permission";

export interface User {
  userId: number;
  oib: string;
  firstName: string;
  lastName: string;
  roleId: KindergartenRoleEnum;
  roleName: string;
  permissions: PermissionEnum[];
  institutionId?: number;
  enrollmentGroupId?: number;
  niasMessageId: string;
  niasNavigationToken: string;
  niasSessionId: string;
}

export const userInitial: User = {
  userId: 0,
  oib: "",
  firstName: "",
  lastName: "",
  roleId: KindergartenRoleEnum.Unknown,
  roleName: "",
  permissions: [],
  niasMessageId: "",
  niasNavigationToken: "",
  niasSessionId: "",
};

export const isUserInEnrollmentGroup = (user: User) => {
  return user.enrollmentGroupId != null;
};

export const isUserAuthorized = (user: User) => {
  return (
    user.roleId !== KindergartenRoleEnum.Unknown &&
    (user.institutionId != null || user.enrollmentGroupId != null)
  );
};
